/* eslint-disable */
import tourCriteriaService from '@/js/common/Domain/Service/tourCriteria';
import './styles/no-tours-banner.scss';
import bannerTemplate from './template.html';
import {propsDecorator, viewModelDecorator} from '@/js/common/Domain/Service/mixins/decorators';

const formFields = {
    priceRange: 'Цена',
    hotelCategories: 'Категория отеля',
    meals: 'Питание',
    hotels: 'Отель',
    resorts: 'Курорт',
    checkInDateRange: 'Дата вылета',
    nightRange: 'Кол-во ночей',
};

@viewModelDecorator({
    defaults: {
        bannerVisible: false,
        havePriceCalendar: null,
        htmlLinksPurpose: '',
        bannerTitleText: 'По выбранным вами критериям поиска нам не удалось найти туры',
        calendarTitleText: 'Воспользуетесь календарем низких цен для поиска дат вылетов с турами по вашим критериям',
    },
})

@propsDecorator({
    bindings: {
        '.no-tours-banner': 'animatedToggle:bannerVisible',
        '.js-epoxy-haveNotPriceCalendar': 'toggle:not(havePriceCalendar)',
        '.js-epoxy-havePriceCalendar': 'toggle:havePriceCalendar, text:calendarTitleText',
        '.no-tours-banner__title': 'text:bannerTitleText',
        '.no-tours-banner__links': 'html:htmlLinksPurpose',
    },
})
export default class NoToursBannerView extends Backbone.Epoxy.View {
    initialize(options = {}) {
        const {
model, controllerModel, bannerTitleText, calendarTitleText,
} = options;
        if (!model) {
            throw new Error('no model provided');
        }
        if (!controllerModel) {
            throw new Error('no controllerModel provided');
        }
        this.model = model;
        this.controllerModel = controllerModel;
        if (bannerTitleText) {
            this.viewModel.set('bannerTitleText', bannerTitleText);
        }
        if (calendarTitleText) {
            this.viewModel.set('calendarTitleText', calendarTitleText);
        }
        this.render();
    }

    render() {
        this.$el.html(bannerTemplate(this.model));
    }

    htmlLinksPurpose(searchData) {
        if (!searchData) return;
        let changedFilters = tourCriteriaService.getMaybeWrongFields(searchData);
            const template = _.template("<li<%= !noClick ? ' class=\"clickable\"' : ''%>><%= name %></li>");
            let html = $();
            const self = this;

        changedFilters = changedFilters.slice(0, 3);

        _.each(changedFilters, (field) => {
            if (field !== 'priceRange') {
                const view = self.controllerModel.get(field).get('view');
                    let element;

                if (view?.label !== 'бюджет') {
                    if (!_.isEmpty(view)) {
                        element = $(template({name: view.label, noClick: false}));

                        element.on('click', (e) => {
                            view.scrollToElement(e);
                        });

                        html = html.add(element);
                    } else if (formFields[field]) {
                        element = $(template({name: formFields[field], noClick: true}));
                        html = html.add(element);
                    }
                }
            }
        });
        return html;
    }

    showBanner(havePriceCalendar) {
        havePriceCalendar ? this.viewModel.set('havePriceCalendar', havePriceCalendar) : this.viewModel.set('htmlLinksPurpose', this.htmlLinksPurpose(this.model.get('searchData')));
        this.viewModel.set('bannerVisible', true);
    }

    hideBanner() {
        this.viewModel.set('bannerVisible', false);
    }
}
